import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as appHelper from '../../helpers/appHelper';
import * as localStorage from '../../localStorage/localStorage';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';

class ExitPrompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            exit_message: appHelper.getLocaleString("goodbye_label"),
            save_and_exit_label: appHelper.getLocaleString("save_and_exit_label"),
            cancel_label: appHelper.getLocaleString("cancel_label"),


        };

        this.onClose = this.onClose.bind(this);
        this.onExit = this.onExit.bind(this);
        this.returnToPortal = this.returnToPortal.bind(this);
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                exit_message: appHelper.getLocaleString("goodbye_label"),
                save_and_exit_label: appHelper.getLocaleString("save_and_exit_label"),
                cancel_label: appHelper.getLocaleString("cancel_label"),
            });
        }
    }

    componentDidUpdate() {

    }

    onClose(event){
        appHelper.closeWindow();
    }

    onExit(){
        this.props.actions.doLMSExit(this.props.tracking_type);
    }

    returnToPortal(){

        window.parent.postMessage({
            'func': 'onExitModule',
            'message': true
        }, "*");
    }

    render() {
        return (
            <div className="init-prompt-content text-center">
                <p>{this.state.goodbye_label}
                    {this.props.trackingData.first_name.length > 0
                        ?
                        <span> {this.props.trackingData.first_name.includes('Guest') ? "" : this.props.trackingData.first_name}</span>
                        :
                        null
                    }
                .</p>
                <p>{this.state.exit_message}</p>
                <br/>
                <div className="object-container">
                    {appHelper.isDefined(localStorage.contentData.experience.use_bridge_exit) && localStorage.contentData.experience.use_bridge_exit
                        ?
                        <button className="btn btn-lg guroo-btn" onClick={this.onExit} id="saveExitBtn" dangerouslySetInnerHTML={{__html: this.state.save_and_exit_label}}/>
                        :
                        appHelper.isDefined(localStorage.contentData.experience.return_to_portal_on_exit) && localStorage.contentData.experience.return_to_portal_on_exit
                            ?
                            <button className="btn btn-lg guroo-btn" onClick={this.returnToPortal} id="saveExitBtn" dangerouslySetInnerHTML={{__html: this.state.save_and_exit_label}}/>
                            :
                            <button className="btn btn-lg guroo-btn" onClick={this.onClose} id="saveExitBtn" dangerouslySetInnerHTML={{__html: this.state.save_and_exit_label}}/>


                    }
                </div>
                <div className="object-container">
                    <button className="btn btn-lg guroo-btn" onClick={this.props.actions.removeDialog} id="cancelExitBtn" dangerouslySetInnerHTML={{__html: this.state.cancel_label}}/>
                </div>
            </div>
        );
    }
}

/*
* {appHelper.isDefined(localStorage.contentData.experience.exit_url) && localStorage.contentData.experience.exit_url.length > 0
                        ?
                        <a className="btn btn-lg guroo-btn" href={localStorage.contentData.experience.exit_url}>Save & Exit</a>
                        :
                        <button className="btn btn-lg guroo-btn" onClick={this.onClose}>Save & Exit</button>
                    }*/

ExitPrompt.propTypes = {
    initData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    tracking_type: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
};

ExitPrompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let tracking_type = "";
    if (appHelper.isDefined(state.contentData.experience)) {
        tracking_type = state.contentData.experience.tracking_type;
    }
    let lang = state.userData.lang;
    return {
        lang:lang,
        initData: state.initData,
        contentData: state.contentData,
        trackingData: state.trackingData,
        tracking_type: tracking_type,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, dialogPopupActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExitPrompt);



/** WEBPACK FOOTER **
 ** ./src/components/initialisation/ExitPrompt.js
 **/